import { datadogRum } from '@datadog/browser-rum'

type User = {
  id: string
  email: string
  role: string
}

export function identifyUserOnMonitoringSession({ id, email, role }: User) {
  const user = {
    id,
    email,
    segment: role,
  }
  datadogRum.setUser(user)
}
